import { render } from "./finance_overview.vue?vue&type=template&id=24dde9a2&scoped=true"
import script from "./finance_overview.vue?vue&type=script&lang=js"
export * from "./finance_overview.vue?vue&type=script&lang=js"

import "./finance_overview.vue?vue&type=style&index=0&id=24dde9a2&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dde9a2"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QIcon,QTd,QBtn});
